import React, { useState, useEffect } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams } from 'react-router-dom';
import UserPostCard from '../../components/UserPostCard';
import Loader from '../../components/Loader';


// friends/other people posts
const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useParams();

  useEffect(() => {
    const getUserPosts = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`/users/${user}/posts`, { params: { page } });
        setIsLoading(false)
        if (response && response.data) {
          setPosts(response.data);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to fetch posts");
      } finally {
        setIsLoading(false);
      }
    };

    getUserPosts();
  }, [user, page]);

  return (
    <div className='userposts-container users-page-container'>
      <div className="userposts-header">
        <h3>Posts</h3>
      </div>
      <div className="userposts">
        {isLoading && <Loader />}

        {!isLoading && posts.length === 0 && (
          <p className="not-found-msg">This user has no posts yet.</p>
        )}

        {posts.length > 0 && (
          <InfiniteScroll
            dataLength={posts.length}
            next={() => setPage((prev) => prev + 1)}
            hasMore={false} 
            loader={<Loader />}
          >
            {posts.map((post) => (
              <UserPostCard userPost={post} key={post._id} />
            ))}
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

export default Posts;
